export default __webpack_public_path__ + "static/media/47UT63.90d2a9cb.png";